import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

function FullPageLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background-50">
      <div className="flex flex-col items-center gap-3">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-primary-200 border-t-primary-500" />
        <p className="text-sm text-foreground-500">Yükleniyor...</p>
      </div>
    </div>
  );
}

export function TeacherGuard() {
  const { user, profile, loading, profileLoading, isTeacher } = useAuth();

  if (loading || profileLoading) return <FullPageLoader />;
  if (!user || !profile) return <Navigate to="/giris" replace />;
  if (!isTeacher) return <Navigate to="/ogrenci" replace />;
  return <Outlet />;
}

export function StudentGuard() {
  const { user, profile, loading, profileLoading, isTeacher } = useAuth();

  if (loading || profileLoading) return <FullPageLoader />;
  if (!user || !profile) return <Navigate to="/giris" replace />;
  if (isTeacher) return <Navigate to="/panel" replace />;
  return <Outlet />;
}